export interface AppSpecs {
  'specs.funnel.StudioTemplatesUseBCatalog': 'true' | 'false';
  studioTemplatesOnlyStudio2: 'true' | 'false';
}

export const defaultAppSpecValues: AppSpecs = {
  'specs.funnel.StudioTemplatesUseBCatalog': 'false',
  studioTemplatesOnlyStudio2: 'false',
};
